// src/client/renderer/character/dice-catch-tuning.ts
//
// Visual staging constants for the board dice catch presentation.
// Calibrate these with assets/dice-catch-tune.html and save through
// POST /api/save-dice-catch-tuning.

export interface DiceCatchTuning {
  rollVisualDurationSeconds: number;
  stretchOverrideMs: number;
  fallbackDurationSeconds: number;
  grabAtRatio: number;
  minStartSeconds: number;
  jumpMinHeight: number;
  jumpMaxHeight: number;
  d20Radius: number;
  d20Scale: number;
  d20PopScale: number;
  diceForwardOffset: number;
  diceCenterYOffset: number;
  backOffset: number;
  sideOffset: number;
  grabClearance: number;
  heroScalePeak: number;
  heroScaleHold: number;
  holdAfterImpactSeconds: number;
  descendSeconds: number;
}

export const DICE_CATCH_TUNING: DiceCatchTuning = {
  rollVisualDurationSeconds: 2.0,
  stretchOverrideMs: 520.0,
  fallbackDurationSeconds: 1.3,
  grabAtRatio: 0.9,
  minStartSeconds: 0.12,
  jumpMinHeight: 0.38,
  jumpMaxHeight: 1.45,
  d20Radius: 0.62,
  d20Scale: 0.86,
  d20PopScale: 0.86,
  diceForwardOffset: 0.0,
  diceCenterYOffset: 0.13,
  backOffset: 0.49,
  sideOffset: -0.185,
  grabClearance: 0.0,
  heroScalePeak: 2.635,
  heroScaleHold: 2.535,
  holdAfterImpactSeconds: 0.0,
  descendSeconds: 0.38,
};
